import AboutUs from './components/AboutUs.vue';
import Contact from './components/Contact.vue';
import Faq from './components/Faq.vue';
import HannahBlog from './components/HannahBlog.vue';
import Home from './components/Home.vue';
import News from './components/News.vue';
import Programs from './components/Programs.vue';
import Quotes from './components/Quotes.vue';
import TraineeGraduates from './components/TraineeGraduates';
import TraineePuppies from './components/TraineePuppies';
import Trainees from './components/Trainees';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

function beforeEnterFunction(to, from, next) {
  // if (store.getters['session/isLoggedIn']) {
  //   next('/events');
  // } else {
  //   next();
  // }

  // you can do something like above to route to other places
  next();
}


const router = new VueRouter(
  { routes: [
    {
      path: '/home',
      component: Home,
      beforeEnter: beforeEnterFunction
    }, {
      path: '/about',
      component: Quotes
    }, {
      path: '/trainees/trainees',
      component: Trainees
    }, {
      path: '/trainees/hannahsblog',
      component: HannahBlog
    }, {
      path: '/trainees/graduates',
      component: TraineeGraduates
    }, {
      path: '/trainees/puppies',
      component: TraineePuppies
    }, {
      path: '/programs',
      component: Programs
    }, {
      path: '/news',
      component: News
    }, {
      path: '/about/us',
      component: AboutUs
    }, {
      path: '/about/faq',
      component: Faq
    }, {
      path: '/contact',
      component: Contact
    }, {
      path: '*',
      redirect: '/about/us'
    }
  ]
});

export default router;


// WEBPACK FOOTER //
// ./src/router.js